<template>
    <div>
        <a-row :gutter="16">
            <a-col class="gutter-row" :span="12">
                <div class="gutter-box">
                    <h2 style="font-weight:bold; margin-bottom:0;">관리자 관리</h2>
                    <p style="color:#888; margin-top:4px;">라인장 이름 목록을 관리합니다.</p>
                </div>
            </a-col>
            <a-col class="gutter-row" :span="12">
                <div class="gutter-box" style="text-align:right;">
                    <a-button type="primary" icon="plus-circle" @click="openAddModal">
                        이름 추가
                    </a-button>
                </div>
            </a-col>
        </a-row>
        <a-divider type="horizontal" />

        <a-table
            :columns="columns"
            :data-source="managerList"
            :row-key="record => record.manager_seq"
            :loading="loading"
            bordered
            size="middle"
            :pagination="{ pageSize: 20 }"
        >
            <template slot="action" slot-scope="text, record">
                <div style="white-space:nowrap;">
                    <a-button size="small" icon="edit" style="margin-right:8px;" @click="openEditModal(record)">수정</a-button>
                    <a-popconfirm
                        title="이 항목을 삭제하시겠습니까?"
                        ok-text="삭제"
                        cancel-text="취소"
                        @confirm="deleteManager(record)"
                    >
                        <a-button size="small" icon="delete" type="danger">삭제</a-button>
                    </a-popconfirm>
                </div>
            </template>
        </a-table>

        <!-- 추가/수정 Modal -->
        <a-modal
            :title="modalMode === 'add' ? '이름 추가' : '이름 수정'"
            :visible="modalVisible"
            @ok="handleModalOk"
            @cancel="closeModal"
            ok-text="저장"
            cancel-text="취소"
        >
            <a-form-item label="이름" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
                <a-input
                    v-model="modalName"
                    placeholder="이름 입력"
                    @pressEnter="handleModalOk"
                />
            </a-form-item>
        </a-modal>
    </div>
</template>

<script>
const columns = [
    { title: 'No', key: 'no', customRender: (text, record, index) => index + 1, width: 60, align: 'center' },
    { title: '이름', dataIndex: 'name', key: 'name' },
    { title: '등록일', dataIndex: 'CREATED', key: 'CREATED', width: 180 },
    { title: '관리', key: 'action', scopedSlots: { customRender: 'action' }, width: 200, align: 'center' },
];

export default {
    name: 'ManagerAdmin',
    data() {
        return {
            columns,
            managerList: [],
            loading: false,
            modalVisible: false,
            modalMode: 'add',
            modalName: '',
            editingSeq: null,
        };
    },
    mounted() {
        this.loadList();
    },
    methods: {
        async loadList() {
            this.loading = true;
            try {
                const res = await this.$http.get(this.$store.state.nodeApiUrl + '/manager/list');
                if (res.data && res.data.code === 'success') {
                    this.managerList = res.data.data;
                }
            } catch (e) {
                this.$message.error('목록 로드 실패: ' + e.message);
            } finally {
                this.loading = false;
            }
        },
        openAddModal() {
            this.modalMode = 'add';
            this.modalName = '';
            this.editingSeq = null;
            this.modalVisible = true;
        },
        openEditModal(record) {
            this.modalMode = 'edit';
            this.modalName = record.name;
            this.editingSeq = record.manager_seq;
            this.modalVisible = true;
        },
        closeModal() {
            this.modalVisible = false;
            this.modalName = '';
            this.editingSeq = null;
        },
        async handleModalOk() {
            const name = this.modalName.trim();
            if (!name) {
                this.$message.warning('이름을 입력해주세요.');
                return;
            }
            try {
                const creator = sessionStorage.getItem('user_name') || 'system';
                if (this.modalMode === 'add') {
                    const res = await this.$http.post(this.$store.state.nodeApiUrl + '/manager/create', { name, creator });
                    if (res.data && res.data.code === 'success') {
                        this.$message.success('추가되었습니다.');
                    }
                } else {
                    const res = await this.$http.put(this.$store.state.nodeApiUrl + `/manager/update/${this.editingSeq}`, { name, updater: creator });
                    if (res.data && res.data.code === 'success') {
                        this.$message.success('수정되었습니다.');
                    }
                }
                this.closeModal();
                this.loadList();
            } catch (e) {
                this.$message.error('저장 실패: ' + e.message);
            }
        },
        async deleteManager(record) {
            try {
                const res = await this.$http.delete(this.$store.state.nodeApiUrl + `/manager/delete/${record.manager_seq}`);
                if (res.data && res.data.code === 'success') {
                    this.$message.success('삭제되었습니다.');
                    this.loadList();
                }
            } catch (e) {
                this.$message.error('삭제 실패: ' + e.message);
            }
        },
    },
};
</script>
